import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Ets2AffidavitSignAcceptPage from './pages/Ets2AffidavitSignAcceptPage';
import Ets2AffidavitsSection from './sections/Ets2AffidavitsSection';
import Header from 'features/shared/layout/header/Header';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import { useTranslation } from 'react-i18next';
import Ets2AffidavitDetailPage from './pages/Ets2AffidavitDetailPage';

type Props = {}

const Ets2Affidavit = (props: Props) => {
  const match = useRouteMatch();
  const { t } = useTranslation(["shared\\moduleNames"]);

  return (
    <Switch>
      <Route path={`${match.path}/:ets2AffidavitId/sign-accept`} component={Ets2AffidavitSignAcceptPage} />
      <Route path={`${match.path}/:ets2AffidavitId`} component={Ets2AffidavitDetailPage} />
      <Route path={match.path}>
        <Header title={t("ets2Affidavits.title")} includeBreadcrumbs />
        <ModuleContent>
          <Ets2AffidavitsSection />
        </ModuleContent>
      </Route>
    </Switch>
  );
}

export default Ets2Affidavit;